// extracted by mini-css-extract-plugin
export default {"wrapper":"Ijww8nsyhmxSTZNyiWY1","card":"sBqn6BWI5IH0OX7PrvuA","multiQuestionHouseCard":"nyU0HvBzimXcIFOyPYv_","nextBtn":"nm8JbKuMmXn6kCeABaIj","houseDataGrid":"KJgJ2A_QKN0FGR9zkaZt"};